/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import Arrow from 'img/icon/arrow-right-circled-contrast.inline.svg'

// Libraries
import parse from 'html-react-parser'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import ParseContent from 'components/shared/ParseContent'
import NationsSeeker from 'components/NationsSeeker'
import Tabs from 'components/Tabs'
import MobileTabs from 'components/MobileTabs'

// Elements
import ImageBackground from 'components/elements/ImageBackground'
import HeroAlt from 'components/elements/HeroAlt'
import HeroDescription from 'components/elements/HeroDescription'
import BlockDefault from 'components/elements/BlockDefault'
import BackgroundDescription from 'components/elements/BackgroundDescription'

// Data
import homeInfo from 'src/graphql/homeInfo'
import Infographic from '../components/Infopgrahic/Infographic'

import FaqArrow from '../img/icon/arrow-right-circled-contrast.inline.svg'
import ButtonDefault from '../components/elements/ButtonDefault'


const FeaturedImage = styled(ImageBackground)`
  padding-top: 50%;
  border-radius: 35px;
  overflow: hidden;
`

const Icon = styled(Arrow)`
  height: 30px;
  width: 30px;
`

const Block = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -200px;
  }

  @media (max-width: 991px) {
    margin-top: -50px;
  }

  @media (max-width: 575px) {
    margin-top: -35px;
  }
`

const Item = styled.div`
  h3 {
    color: ${({ theme }) => theme.color.text.contrast};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      content

      acf {
        banner {
          title
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        meta {
          description
          link {
            title
            url
          }
        }

        faq_questions {
          question
          answer
        }

        content {
          tekst
          link {
            title
            url
          }
        }

        usps {
          title
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          items {
            title
            description
          }
        }

        tabstitle

        tabs {
          title
          tab_name
          description
          cta {
            title
            button {
              title
              url
            }
          }
        }

        extra {
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description
          questions_extra {
            question
            answer
          }
          background_description
        }
        
        outro {
          description
          link {
            title
            url
          }
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }

        faq {
          title
          items {
            question
            answer
          }
        }

        show_infographic
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf },
  },
}) => {
  const homeFields = homeInfo.get()
  const [activeIndex, setActiveIndex] = React.useState(0)
  const [indexOpen, setIndexOpen] = React.useState(0)
  const [uspIndexOpen, setUspIndexOpen] = React.useState(null)

  const [faqActiveIndex, setFaqActiveIndex] = useState(0)

  const setOpen = (index) => {
    setUspIndexOpen(index === uspIndexOpen ? null : index)
  }

  const toggleFaq = (index) => {
    setFaqActiveIndex(faqActiveIndex === index ? -1 : index)
  }

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index)

    const item = document.getElementById(`tabitem-${index} `)
    // Scroll to the top of the TabItem when its h3 is clicked
    window.scrollTo({
      top: item.offsetTop - 1000,
      behavior: 'smooth',
    })
    // Your other toggleAccordion logic here
  }

  const toggleAccordionExtra = (index) => {
    setIndexOpen(indexOpen === index ? -1 : index)

    const item = document.getElementById(`extra-tabitem-${index} `)
    // Scroll to the top of the TabItem when its h3 is clicked
    window.scrollTo({
      top: item.offsetTop - 1000,
      behavior: 'smooth',
    })
    // Your other toggleAccordion logic here
  }

  if (path === '/faq/') {
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: acf.faq_questions.map((question) => ({
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.answer,
        },
      })),
    }

    React.useEffect(() => {
      if (typeof window !== 'undefined') {
        const script = document.createElement('script')
        script.type = 'application/ld+json'
        script.innerHTML = JSON.stringify(structuredData)
        document.head.appendChild(script)
      }
    }, [structuredData])
  }

  const Content = styled(ParseContent)`
    & h1,
    & h2,
    & h3,
    & h4,
    & h5 {
      color: ${(props) => props.theme.color.text.contrast};
    }
  `
  const FaqItem = styled.div`
    h3 {
      color: ${({ theme }) => theme.color.text.contrast};
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  `

  const FaqIcon = styled(FaqArrow)`
  height: 30px;
  width: 30px;
`

const ContentTitle = styled(ParseContent)`
  & h2 {
    font-size: ${(props) => props.theme.font.size['50']};
  }
`

console.log(acf)

  return (
    <Layout>
      <SEO
        yoast={yoast}
        path={path}
        image={{
          url:
            acf.banner.image.localFile &&
            acf.banner.image.localFile.childImageSharp.openGraph.src,
        }}
      />

      <section>
        <HeroAlt small image={acf.banner.image}>
          <HeroDescription className="d-flex align-items-center justify-content-start h-100">
            {parse(acf.banner.title)}
          </HeroDescription>
        </HeroAlt>
      </section>

      <section>
        <div className="container pb-5 mt-n5">
          <div className="row">
            <div className="col-lg-4" />
            <div className="col-lg-8">
              <BlockDefault className="mt-lg-n5" bigBorderRadius>
                {acf.faq_questions && acf.faq_questions.length > 0 ? (
                  acf.faq_questions.map((question, index) => {
                    const status = activeIndex === index ? 'open' : 'closed'

                    return (
                      <Item key={index} className="mb-4">
                        <div
                          className="d-flex align-items-start justify-content-between"
                          onClick={() => toggleAccordion(index)}
                          role="button"
                        >
                          <ParseContent
                            className="mr-3"
                            content={question.question}
                          />
                          <motion.div
                            initial="open"
                            variants={{
                              open: { rotate: 90 },
                              closed: { rotate: 0 },
                            }}
                            animate={status}
                          >
                            <Icon />
                          </motion.div>
                        </div>

                        <motion.div
                          initial="open"
                          variants={{
                            open: { opacity: 1, height: 'auto' },
                            closed: { opacity: 0, height: 0 },
                          }}
                          animate={status}
                          className="overflow-hidden"
                        >
                          <div className="mt-2">
                            <ParseContent content={question.answer} />
                          </div>
                        </motion.div>
                      </Item>
                    )
                  })
                ) : (
                  <>
                    <ParseContent content={acf.meta.description} />
                    {acf.meta.link && (
                      <ButtonDefault to={acf.meta.link.url} className="mt-4">{acf.meta.link.title}</ButtonDefault>
                    )}
                  </>
                )}
              </BlockDefault>
            </div>
          </div>
        </div>
      </section>

      {acf.content && (
        <section>
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-10">
              <ParseContent content={acf.content.tekst} />
                {acf.content.link && (
                  <ButtonDefault to={acf.content.link.url} className="mt-4">{acf.content.link.title}</ButtonDefault>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

  {acf.usps && acf.usps.title && acf.usps.items && acf.usps.items.length > 0 && (
      <section>
        <div className="container py-5">
          <div className="row">
            <div className='col-lg-10'>
              <Content content={acf.usps.title} className="mb-5" />
            </div>

            <div className="col-lg-5">  
              {acf.usps.items.map(({ title, description }, index) => (
                <USP 
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  title={title} 
                  description={description} 
                  index={index}
                  setOpen={setOpen}
                  indexOpen={uspIndexOpen}
                /> 
              ))}
            </div>
            <div className='col-lg-7'>
              <FeaturedImage src={acf.usps.image} className="h-100 object-fit-cover" />
            </div>
          </div>
        </div>
      </section>
    )}

      {acf.tabs && acf.tabs.length > 0 && (
        <section id="tabInfo" className="pt-lg-5">
        <div className="container py-5 ">
          <div className="row pt-lg-5 pb-0 pb-lg-5">
            <div className="col-12 d-flex justify-content-end px-lg-0 mb-4 mb-lg-0">
              <ContentTitle content={acf.tabstitle} />
            </div>
          </div>
          <Tabs className="d-none d-lg-flex" fields={acf.tabs} />
          <MobileTabs className="d-lg-none" content={acf.tabs} />
        </div>
      </section>
      )}

    {acf.outro && (
        <section>
          <div className="container">
            <div className="row py-5">
              <div className="col-lg-10">
              <ParseContent content={acf.outro.description} />
              {acf.outro.link && (
                <ButtonDefault to={acf.outro.link.url} className="mt-4">{acf.outro.link.title}</ButtonDefault>
              )}
              </div>
            </div>
          </div>
        </section>
      )}

      {acf.extra.questions_extra && acf.extra.questions_extra.length > 0 && (
        <section>
          <div className="container">
            <BackgroundDescription
              className="mt-3"
              content={acf.extra.background_description}
              relative
            />

            <div className="row">
              <div className="col-lg-2" />
              <div className="col-lg-10">
                <FeaturedImage src={acf.extra.image} />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-7">
                <Block bigBorderRadius>
                  {acf.extra.questions_extra.map((questionExtra, index) => {
                    const status = indexOpen === index ? 'open' : 'closed'

                    return (
                      <Item key={index} className="mb-4">
                        <div
                          className="d-flex align-items-start justify-content-between"
                          onClick={() => toggleAccordionExtra(index)}
                          role="button"
                        >
                          <ParseContent
                            content={questionExtra.question}
                            className="mr-3"
                          />
                          <motion.div
                            initial="open"
                            variants={{
                              open: { rotate: 90 },
                              closed: { rotate: 0 },
                            }}
                            animate={status}
                          >
                            <Icon />
                          </motion.div>
                        </div>
                        <motion.div
                          initial="open"
                          variants={{
                            open: { opacity: 1, height: 'auto' },
                            closed: { opacity: 0, height: 0 },
                          }}
                          animate={status}
                          className="overflow-hidden"
                        >
                          <div className="mt-2">
                            <ParseContent content={questionExtra.answer} />
                          </div>
                        </motion.div>
                      </Item>
                    )
                  })}
                </Block>
              </div>
              <div className="col-lg-5" />
            </div>
          </div>
        </section>
      )}

      {parse(acf.extra.description)[0].props.children !== 'empty' && (
        <section>
          <div className="container">
            <BackgroundDescription
              className="mt-3"
              content={acf.extra.background_description}
              relative
            />

            <div className="row">
              <div className="col-lg-2" />
              <div className="col-lg-10">
                <FeaturedImage src={acf.extra.image} />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-7">
                <Block bigBorderRadius>
                  <ParseContent content={acf.extra.description} />
                </Block>
              </div>
              <div className="col-lg-5" />
            </div>
          </div>
        </section>
      )}

      <section>
        <div className="container mt-5 pt-5">
          <BackgroundDescription
            content={homeFields.acf.identity.background_description}
            relative
          />
        </div>
      </section>

      <section>
        <div className="container pb-5 mb-lg-5">
          <NationsSeeker fields={homeFields.acf.search} />
        </div>
      </section>

      {acf.faq && acf.faq.title && (
      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-10">
              <Content content={acf.faq.title} className="mb-5" />
              {acf.faq.items && acf.faq.items.length > 0 && (
                <BlockDefault bigBorderRadius>
                  {acf.faq.items.map((question, index) => {
                    const status = faqActiveIndex === index ? 'open' : 'closed'

                    return (
                      <FaqItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        className="mb-4"
                      >
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <div
                          className="d-flex align-items-start justify-content-between"
                          onClick={() => toggleFaq(index)}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              event.preventDefault()
                              toggleFaq(index)
                            }
                          }}
                          role="button"
                          tabIndex={0}
                          aria-expanded={status === 'open'}
                        >
                          
                          <h3 className='mr-3'>{question.question}</h3>
                          <motion.div
                            initial="open"
                            variants={{
                              open: { rotate: 90 },
                              closed: { rotate: 0 },
                            }}
                            animate={status}
                          >
                            <FaqIcon />
                          </motion.div>
                        </div>

                        <motion.div
                          initial="open"
                          variants={{
                            open: { opacity: 1, height: 'auto' },
                            closed: { opacity: 0, height: 0 },
                          }}
                          animate={status}
                          className="overflow-hidden"
                        >
                          <div className="mt-2">
                            <ParseContent content={question.answer} />
                          </div>
                        </motion.div>
                      </FaqItem>
                    )
                  })}
                </BlockDefault>
              )}
            </div>
          </div>
        </div>
      </section>
    )}

      {acf.show_infographic && <Infographic />}
    </Layout>
  )
}

const StyledUSP = styled(BlockDefault)`
  background-color: ${props => props.theme.color.contrast};
  color: ${props => props.theme.color.text.light};
  border-radius: 25px;
  
  & h1, & h2, & h3 {
    font-weight: ${props => props.theme.font.weight.s};
    margin: 0;

    & strong, & b {
      font-weight: ${props => props.theme.font.weight.xl};
    }
  }

  @media (min-width: 992px) {
    padding: 25px 35px !important;
    max-width: 400px;
  }

  @media (max-width: 991px) {
    padding: 15px 25px !important;
    width: 100%;
  }
`

const Title = styled(motion.div)`
  &:hover {
    text-decoration: underline;
  }
`

const USPIcon = styled(Arrow)`
  height: 40px;
  width: 40px;
`

const Description = styled(motion.div)`
  overflow: hidden;
`

export const USP = ({ title, description, index, indexOpen, setOpen }) => {
  const status = indexOpen === index ? 'open' : 'closed'

  return (
    <StyledUSP className="mb-3">
      <Title
        role="button"
        className="d-flex justify-content-between align-items-center"
        onClick={() => {
          setOpen(index)
        }}
      >
        {parse(title)}
        <motion.div
          initial="open"
          variants={{
            open: { rotate: 90 },
            closed: { rotate: 0 },
          }}
          animate={status}
        >
          <USPIcon />
        </motion.div>
      </Title>
      <Description
        initial="open"
        variants={{
          open: { opacity: 1, height: 'auto' },
          closed: { opacity: 0, height: 0 },
        }}
        animate={status}
      >
        <div className="mt-3">
          <ParseContent content={description} />
        </div>
      </Description>
    </StyledUSP>
  )
}

export default PageTemplate
